import { BUTTON_CAD, BUTTON_USD, BUTTON_GBP, BUTTON_AUD, BUTTON_EUR } from "../components/style/colors";
export var PRODUCTION_ENV = process.env.NODE_ENV === 'production';
export var DOLLAR_SIGN = '$';
export var POUND_SIGN = '£';
export var CAD = 'CA$';
export var USD = 'US$';
export var AUD = 'AU$';
export var GBP = 'GB£';
export var EUR = 'EU€';
export var CAD_NEW = 'CAD';
export var USD_NEW = 'USD';
export var US_WORK_VISA_LINK = 'https://www.uscis.gov/working-united-states/students-and-exchange-visitors/students-and-employment';
export var UK_WORK_VISA_LINK = 'https://www.ukcisa.org.uk/Information--Advice/Working/Tier-4-work';
export var AU_WORK_VISA_LINK = 'https://www.studyinaustralia.gov.au/english/live-in-australia/working';
export var ACTIVE_COLOR = '#7ed321';
export var INACTIVE_COLOR = '#d0021b';
export var ACCOUNT_STUDENT = 'student_account';
export var ACCOUNT_AGENT = 'agent_account';
export var dateFormat = 'YYYY-MMM-DD';
export var dateTimeFormat = 'YYYY-MMM-DD HH:mm';
export var dateTimeSecondsFormat = 'YYYY-MM-DD HH:mm:ss';
export { API_ROOT } from '@applyboard/ui-utils';
export var API_PREFIX = '/api/v0.1';
export var API_APPLICATION_PREFIX = "".concat(API_PREFIX, "/applications");
export var ButtonColor = {
  CAD: BUTTON_CAD,
  USD: BUTTON_USD,
  GBP: BUTTON_GBP,
  AUD: BUTTON_AUD,
  EUR: BUTTON_EUR
};
export var INTAKE_MONTHS = {
  fall: [8, 9, 10, 11],
  summer: [4, 5, 6, 7],
  winter: [12, 1, 2, 3]
};
export var OTHER_OPTIONS = [{
  label: 4,
  value: 4
}, {
  label: 5,
  value: 5
}, {
  label: 7,
  value: 7
}, {
  label: 10,
  value: 10
}, {
  label: 20,
  value: 20
}, {
  label: 100,
  value: 100
}];
export var REMOVE_REQUIREMENT_MODAL_IDENTIFIER = 'remove-requirement';
export var APPLICATION_STATUSES = {
  'pre-payment': [{
    label: 'Undecided',
    value: 'undecided'
  }],
  'pre-submission': [{
    label: 'Undecided',
    value: 'undecided'
  }],
  submission: [{
    label: 'Undecided',
    value: 'undecided'
  }],
  'post-submission': [{
    label: 'Undecided',
    value: 'undecided'
  }],
  admission: [{
    label: 'Accepted',
    value: 'accepted'
  }],
  'visa-application': [{
    label: 'Accepted',
    value: 'accepted'
  }],
  'post-decision': [{
    label: 'Accepted',
    value: 'accepted'
  }],
  'pre-arrival': [{
    label: 'Accepted',
    value: 'accepted'
  }],
  refund: [{
    label: 'Accepted',
    value: 'accepted'
  }],
  general: [],
  deferral: []
};
export var APPLICATION_STATUS_OPTIONS = [{
  label: 'Undecided',
  value: 'undecided'
}, {
  label: 'Accepted',
  value: 'accepted'
}, {
  label: 'Rejected',
  value: 'rejected'
}, {
  label: 'Cancelled',
  value: 'cancelled'
}, {
  label: 'Withdrawn',
  value: 'withdrawn'
}];
export var REQUIREMENT_STATUSES = {
  'pre-payment': [{
    label: 'Pre-payment',
    value: 'pre-payment'
  }],
  'pre-submission': [{
    label: 'Pre-submission',
    value: 'pre-submission'
  }],
  submission: [{
    label: 'Submission',
    value: 'submission'
  }],
  'post-submission': [{
    label: 'Post-submission',
    value: 'post-submission'
  }],
  admission: [{
    label: 'Admission',
    value: 'admission'
  }],
  'visa-application': [{
    label: 'Visa-application',
    value: 'visa-application'
  }],
  'post-decision': [{
    label: 'Post-decision',
    value: 'post-decision'
  }],
  'pre-arrival': [{
    label: 'Pre-arrival',
    value: 'pre-arrival'
  }],
  refund: [{
    label: 'Refund',
    value: 'refund'
  }],
  general: [{
    label: 'General',
    value: 'general'
  }],
  deferral: [{
    label: 'Deferral',
    value: 'deferral'
  }]
};
export var REQUIREMENT_STATUS_OPTIONS = [{
  label: 'Pre-payment',
  value: 'pre-payment'
}, {
  label: 'Pre-submission',
  value: 'pre-submission'
}, {
  label: 'Submission',
  value: 'submission'
}, {
  label: 'Post-submission',
  value: 'post-submission'
}, {
  label: 'Admission',
  value: 'admission'
}, {
  label: 'Visa-application',
  value: 'visa-application'
}, {
  label: 'Post-decision',
  value: 'post-decision'
}, {
  label: 'Pre-arrival',
  value: 'pre-arrival'
}, {
  label: 'Arrival',
  value: 'arrival'
}, {
  label: 'Deferral',
  value: 'deferral'
}, {
  label: 'Refund',
  value: 'refund'
}, {
  label: 'General',
  value: 'general'
}];
export var ALL_UNDERGRADUATE_LEVELS = ['certificate', 'diploma', '3_year_bachelors', 'advanced_diploma', 'bachelors', 'english'];
export var ALL_K_12_LEVELS = ['grade_1', 'grade_10', 'grade_11', 'grade_12', 'grade_2', 'grade_3', 'grade_4', 'grade_5', 'grade_6', 'grade_7', 'grade_8', 'grade_9'];
export var NEW_SEARCH_COOKIE_NAME = 'useNewSearch2';
export var TUITIONS_TIP = 'Please be advised that the amount indicated below is an estimate provided by the school and subject to change. This amount varies based on the fixed amount from the school or net tuition the school recieves from the student.';
export var TUITION_FEE_DISCLAIMER = 'Please note that tuition fees may vary depending on the type and amount of courses that a student enrolls in. Tuition is subject to change without notice and annual increases.';
export var DEFAULT_OPEN_DATE_PASSED = 'The school has started to accept applications for this intake on ';
export var DEFAULT_OPEN_DATE_NOT_PASSED = 'The school will start accepting applications for this intake on ';
export var DEFAULT_OPEN_DATE_NOT_EXISTS = 'The date in which the school starts to accept applications for this intake is still unknown.';
export var PGWP_CANADA = 'Post-Grad Work Permit';
export var NO_PGWP_CANADA_TIP = 'Ineligible for Post-Grad Work Permit';
export var PGWP_UK = 'Post-Study Work Visa';
export var NO_PGWP_UK_TIP = 'Ineligible for Post-Study Work Visa';
export var PGWP_USA = 'Optional Practical Training';
export var NO_PGWP_USA_TIP = 'Ineligible for Optional Practical Training';

// Roles
export var SYS_ADMIN = 'sys_admin';
export var ADMIN = 'admin';
export var AGENT = 'agent';
export var AGENT_MANAGER = 'agent_manager';
export var AGENT_REGIONAL_MANAGER = 'agent_regional_manager';
export var STUDENT = 'student';
export var VISITOR = 'visitor';
export var INTERNATIONAL_RECRUITMENT_OFFICER = 'international_recruitment_officer';
export var EXTERNAL_CONTRACTOR = 'external_contractor';
export var CONTENT_EDITOR = 'content_editor';
export var STUDENT_ADVISOR = 'student_advisor';
export var SALES_PERSON = 'sales_person';

// Payments
export var ADDRESS = 'address';
export var AGENT_INFORMATION = 'agent_information';
export var APPLICATION = 'application';
export var BILLING_ACCOUNT = 'billing_account';
export var COMMISSION_POLICY = 'commission_policy';
export var COMMISSION_TIER = 'commission_tier';
export var DIRECT = 'Direct';
export var ORDER = 'order';
export var ORDER_ITEM = 'order_item';
export var PERSONAL_INFORMATION = 'personal_information';
export var PROGRAM = 'program';
export var RP = 'Recruitment Partner';
export var USER = 'User';
export var USER_TYPE = 'user';

// Applications
export var ApplicationRelationshipType = /*#__PURE__*/function (ApplicationRelationshipType) {
  ApplicationRelationshipType["USER"] = "user";
  ApplicationRelationshipType["AGENT_INFORMATION"] = "agent_information";
  ApplicationRelationshipType["PERSONAL_INFORMATION"] = "personal_information";
  ApplicationRelationshipType["ADDRESS"] = "address";
  ApplicationRelationshipType["SALES_REPRESENTATIVE"] = "sales_representative";
  ApplicationRelationshipType["STUDENT_INFORMATION"] = "student_information";
  ApplicationRelationshipType["PAYMENT"] = "payment";
  ApplicationRelationshipType["MANUAL_PAYMENT"] = "manual_payment";
  ApplicationRelationshipType["ORDER_ITEM"] = "order_item";
  ApplicationRelationshipType["APPLICATION_STAGE"] = "application_stage";
  ApplicationRelationshipType["PROGRAM"] = "program";
  ApplicationRelationshipType["SCHOOL"] = "school";
  ApplicationRelationshipType["APPLICATION_SERVICE_FEE_CHARGE"] = "application_service_fee_charge";
  ApplicationRelationshipType["APPLICATION_SERVICE_FEE"] = "application_service_fee";
  return ApplicationRelationshipType;
}({});
export var YES_NO_OPTIONS = ['Yes', 'No'];
export var TOEFL_NOT_REQUIRED_BAND_SCORE = 1;
export var IELTS_NOT_REQUIRED_BAND_SCORE = 1;
export var PTE_NOT_REQUIRED_BAND_SCORE = 10;
export var GMAT_NOT_REQUIRED_BAND_SCORE = 1;
export var APPLY_ASSIST_KNOWLEDGE_BASE_URL = 'https://zendesk-service.applyboard.com/api/v1/session/create?relay_state=https%3A%2F%2Fassist.applyboard.com';
export var APPLY_ASSIST_RECRUITER_NEWS_URL = 'https://zendesk-service.applyboard.com/api/v1/session/create?relay_state=https%3A%2F%2Fassist.applyboard.com/hc/en-us/categories/360004584614-Recruiter-News';
export var CONCORDIA_CONTINUING_EDUCATION_ID = 943;
export var STRIPE_INJECTABLE_SCRIPT_URL = 'https://js.stripe.com/v3/';
export var BRAINTREEGATEWAY_INJECTABLE_SCRIPT_URL = 'https://js.braintreegateway.com/web/3.25.0/js/client.min.js';